export const interweave = (arr, item) =>
  [].concat(...arr.map(n => [n, item])).slice(0, -1)

export const halfString = s => {
  let middle = Math.floor(s.length / 2)
  let before = s.lastIndexOf(' ', middle)
  let after = s.indexOf(' ', middle + 1)

  if (before == -1 || (after != -1 && middle - before >= after - middle)) {
    middle = after
  } else {
    middle = before
  }

  const s1 = s.substr(0, middle)
  const s2 = s.substr(middle + 1)

  return [s1, s2]
}
